import ExcludedDomainTypes from 'store/actionTypes/excludedDomain'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  current: {}
}

const ExcludedDomain = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ExcludedDomainTypes.GET_EXCLUDED_DOMAINS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default ExcludedDomain
